const DEFAULT_MESSAGE =
  'Ведутся технические работы. Приложение скоро снова заработает — загляните чуть позже.';

/** Full-screen stub shown to players while the app is in maintenance mode. */
export function MaintenanceScreen({ message }: { message?: string | null }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '32px 24px',
        gap: 16,
      }}
    >
      <div style={{ fontSize: 56, lineHeight: 1 }}>🛠️</div>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Технические работы</h1>
      <p style={{ fontSize: 15, opacity: 0.75, maxWidth: 360, margin: 0 }}>
        {message?.trim() || DEFAULT_MESSAGE}
      </p>
    </div>
  );
}
